import type { PopupsListParams } from '@/Swagger';

export const 팝업_쿼리_키 = {
  all: ['팝업_쿼리_키'] as const,
  list: (query?: PopupsListParams) => [...팝업_쿼리_키.all, query],
};
